import axiosInstance from '../api/axios';

export interface contentReportParams {
  contentId: string;
  message: string;
  type: 'Lesson' | 'Exercise' | 'Material' | 'Live';
}

export async function reportContent(params: contentReportParams) {
  const response = await axiosInstance.post(`/content/report`, {
    contentId: params.contentId,
    message: params.message,
    type: params.type,
    platform: 'Morpheus',
  });

  return response.data;
}
